<div [hidden]="!(ce && cn && cc)">
    <div class="flex-row">
        <div hidden></div>
        <div [ngClass]="{'stripe-error': stripeError || error}" class="container-input-card-1" #cardNumber></div>
        <div [ngClass]="{'stripe-error': stripeError || error}" class="container-input-card-2" #cardExpiry>
        </div>
        <div [ngClass]="{'stripe-error': stripeError || error}" class="container-input-card-3" #cardCvc></div>
    </div>
</div>

<div [hidden]="(ce && cn && cc)">
    <div class="spinner-container">
        <div class="loading-spinner-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </div>
</div>